
import Vue from 'vue';
import filters from '@/filters';
import Component from 'vue-class-component';
import { Action, State } from 'vuex-class';
import { Watch } from 'vue-property-decorator';
import toast from '@/functions/toast.function';

@Component({
  filters,
})
export default class VerifyDetail extends Vue {
  /* VUEX */

  // ACTION
  @Action('actionSelectCandidateById', { namespace: 'candidate' })
  private actionSelectCandidateById: any;
  @Action('actionApproveCandidate', { namespace: 'candidate' })
  private actionApproveCandidate: any;
  @Action('actionRejectCandidate', { namespace: 'candidate' })
  private actionRejectCandidate: any;
  @Action('actionResetCandidate', { namespace: 'candidate' })
  private actionResetCandidate: any;
  @Action('actionCandidateResend', { namespace: 'candidate' })
  private actionCandidateResend: any;
  @Action('actionCandidateSaveEdit', { namespace: 'candidate' })
  private actionCandidateSaveEdit: any;

  // STATE
  @State('candidate_verify', { namespace: 'candidate' })
  private candidate: any;

  private formCandidate = {
    nim: '',
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
  };

  private onResendEmail: boolean = false;
  private onSubmit: boolean = false;
  private isShow: boolean = false;
  private get isEmailChanged(): boolean {
    return this.formCandidate.email !== this.candidate.user.email;
  }
  private get formChanged(): boolean {
    return (
      this.formCandidate.nim !== this.candidate.nim ||
      this.formCandidate.first_name !== this.candidate.user.first_name ||
      this.formCandidate.last_name !== this.candidate.user.last_name ||
      this.formCandidate.email !== this.candidate.user.email ||
      (this.formCandidate.phone as string).replace(/\s/g, '') !== (this.candidate.phone as string).replace(/\s/g, '')
    );
  }
  private get isValidEmail(): boolean {
    /* tslint:disable */
    const mailformat = new RegExp(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
    /* tslint:enable */
    return mailformat.test(this.formCandidate.email);
  }

  private get isValidPhone() {
    const isContainLetter = new RegExp(/^[A-Za-z]+$/);
    if (!isContainLetter.test(this.formCandidate.phone)) {
      const phoneFormat = new RegExp(/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g);
      return phoneFormat.test(this.formCandidate.phone);
    } else {
      return false;
    }

  }

  /* INITIALIZATION */

  constructor() {
    super();
  }

  private created() {
    this.formCandidate.nim = this.candidate.nim;
    this.formCandidate.first_name = this.candidate.user.first_name;
    this.formCandidate.last_name = this.candidate.user.last_name;
    this.formCandidate.email = this.candidate.user.email;
    this.formCandidate.phone = (this.candidate.phone as string).replace(/\s/g, '');
  }

  /* LIFECYCLE */

  private beforeDestroy() {
    this.actionResetCandidate();
  }

  /* METHOD */
  private resetForm() {
    this.formCandidate = {
      nim: '',
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
    };
  }

  private cancel() {
    this.resetForm();
    this.$emit('update:onEdit', false);
  }

  private checkValid() {
    let is_valid = true;
    if (is_valid && !this.formCandidate.nim) {
      toast.warning(this.$t('warning_nim'));
      is_valid = false;
      return;
    }
    if (is_valid && !this.formCandidate.first_name) {
      toast.warning(this.$t('warning_first_name'));
      is_valid = false;
      return;
    }
    if (is_valid && !this.formCandidate.email) {
      toast.warning(this.$t('warning_email'));
      is_valid = false;
      return;
    }

    if (this.formCandidate.phone) {
      if (is_valid && !this.isValidPhone) {
        toast.warning(this.$t('warning_phone_format'));
        is_valid = false;
        return false;
      }
    }

    this.isShow = is_valid;
  }

  private saveCandidate() {
    this.onSubmit = true;
    this.actionCandidateSaveEdit({
      id: this.candidate.id,
      params: this.formCandidate,
    })
      .then((res: any) => {
        this.onSubmit = false;
        this.$emit('update:onEdit', false);
        this.resetForm();
      })
      .catch((this.onSubmit = false));
  }

  private onClickResendEmail(on_submit: boolean) {
    this.onResendEmail = true;
    this.onSubmit = on_submit;
    this.actionCandidateResend({
      id: this.candidate.id,
      params: this.formCandidate,
    })
    .then(this.onSubmit = this.onResendEmail = false)
    .catch(this.onSubmit = this.onResendEmail = false);
  }

  private listenerAction() {
    this.actionSelectCandidateById(this.candidate.id);
  }
}
